import { useTranslation } from 'react-i18next';
import IconButton from "mobily-ui-library/lib/components/composite/iconButton/IconButton";
import Typography from "mobily-ui-library/lib/components/primitive/Typography/Typography";
import './Error.scss';

export interface Props {
    rtl: boolean;
}

function Error({ rtl }: Props) {
    const { t } = useTranslation();
    const dir = rtl ? 'right': 'left';

    const win: any = window;

    const handleGoBackHome = () => {
        window.location = win['home_page_url'];
    }

    const handleGoBackAccountInfo = () => {
        window.location = win['submit_order_page_url'];
    }

    return (
        <div className="container">
            <div className="row">
                <div className={`col-sm-12 error-container fontFamily-${dir}`}>
                    <Typography className={`error-text error-${dir}`} rtl={rtl}>
                        {t('Failed_to_submit')}
                    </Typography>
                    <div className={`goback-buttons-group-${dir} `}>
                        <IconButton className='goback-accountpage-btn' rtl={rtl} onClick={handleGoBackAccountInfo}>{t('GoBack_Account_Information')}</IconButton>
                    </div>
                        <IconButton primary={false} className='goback-HomePage' rtl={rtl} onClick={handleGoBackHome}>{t('GoBack_Homepage')}</IconButton>
                </div>
            </div>
        </div>
    )
}

export default Error
